import React, {useState} from 'react';
import { GridItem, Button, Flex, Tooltip, Modal, Box, Text, HStack, ModalOverlay, ModalContent, ModalHeader, ModalBody, ModalFooter, IconButton, VStack } from '@chakra-ui/react';
import {useParams, useNavigate} from 'react-router-dom'
import apiClient from '../../clients/apiClient.js';
import { borderColor, fontFamily, fontSize, fontWeight } from '@mui/system';
import { FolderOpenOutlined } from '@mui/icons-material';
import DownloadFile, { DownloadFile2 } from '../../components/DownloadFile';

const TopRight = ({
    formData, setFormData,
    selectedTab, setSelectedTab,
    selectedSection,  
    updatedData, setUpdatedData,
}) => {
    const {formId} = useParams()
    const selectedStyles = {
        backgroundColor: "transparent",
        border: "none",
        borderBottom: "4px solid #2584fd",
        color: "#2584fd",
        borderRadius: "0",
        marginTop: "42px",
        paddingBottom: "8px",
        fontFamily: "sans-serif",
        fontWeight: "600",
        fontSize: "16px",
    }

    const unselectedStyles = {
        backgroundColor: "transparent",
        border: "none",
        borderBottom: "3px solid #e5e5e5",
        color: "#1d1d1d",
        borderRadius: "0",
        marginTop: "42px",
        paddingBottom: "8px",
        fontFamily: "sans-serif",
        fontSize: "16px",
        fontWeight: "400",
    }

    const navigate = useNavigate()

    const getFillResponse = () => {
        let fillResponseCount = 0
        // console.log("[Form][Session] form data in fill response top right",formData,selectedSection)
        for (let i = 0; i < formData?.sections?.length; i ++) {
            if (formData?.sections[i].index == selectedSection) {
                fillResponseCount = formData?.sections[i].fill_response ? formData?.sections[i].fill_response.length : 0
                break
            }
        }

        // console.log("[Form][Session] response count in fill response top right",fillResponseCount)
        if (fillResponseCount > 0) {
            return (
            <Button
                style = {selectedTab === "fill" ? selectedStyles: unselectedStyles}
                onClick={() => setSelectedTab("fill")}
            > Needs input </Button>
        )} else if (selectedSection !== '' && selectedSection != null) {
            setSelectedTab("review")
        }

        return null
    }

    const getReviewResponse = () => {
        let reviewResponseCount = 0
        for (let i = 0; i < formData?.sections?.length; i ++) {
            // console.log("[Form][Session] iteration over review", formData?.sections[i].index, selectedSection)
            if (formData?.sections[i].index == selectedSection) {
                // console.log("[Form][Session] iteration over review", formData.sections[i], formData.sections[i].review_response)
                reviewResponseCount = formData?.sections[i].review_response?.length
                break
            }
        }

        // console.log("[Form][Session] response count in review response top right",reviewResponseCount)
        if (reviewResponseCount > 0) { return (
            <Button 
                style = {selectedTab === "review" ? selectedStyles: unselectedStyles}
                onClick={() => setSelectedTab("review")}
            > Needs review </Button>
        )} else if (selectedSection !== '' && selectedSection != null) {
            setSelectedTab('fill')
        }

        return null
    }

    const saveChanges = async () => {
        if (updatedData.length == 0) {
            return
        }
        try {
            apiClient.post('/forms/save-form-data', { 
                form_id: formId,
                entities: updatedData,
            }).then(({data}) => {
                window.location.reload();
            })
            console.log('Files uploaded successfully');
        } catch (error) {
          console.error('File upload failed:', error);
        }
    }

    const updateDocument = () => {
        try {
            apiClient.post('/forms/update-document', { 
                form_id: formId,
            }).then(({data}) => {
                console.log("[Form][Finalize and export] data is", data)
                DownloadFile2(data?.file_id)
                let taskId = formData?.metadata?.task_id
                if (taskId == "") {
                    navigate('/')
                } else {
                    navigate('/t/'+taskId)
                }
                console.log('Final Form updated successfully');
            })
        } catch (error) {
            console.error('Final Form update failed:', error);
        }
    }

    const saveFinalChanges = () => {
        if (updatedData.length == 0) {
            updateDocument()
            return
        }
        try {
            apiClient.post('/forms/save-form-data', { 
                form_id: formId,
                entities: updatedData,
            }).then(({data}) => {
                setUpdatedData([])
                data.sections?.sort((a,b) => {
                    return a.section_name.localeCompare(b.section_name)
                })
                for (let i = 0; i < data?.sections.length; i++) {
                    data.sections[i].index = i;
                }
                console.log("[Form] post data for save form data is", data)
                setFormData(data)
                console.log('Forms updated successfully');

                updateDocument()
            })
        } catch (error) {
          console.error('Form update failed:', error);
        }
    }

    const [isModalOpen, setIsModalOpen] = useState(false);

    return (
        <GridItem area="logbar" bg="white" p={0} overflowX="auto" height="100%"
            display="flex"
            justifyContent="center"
            alignItems="center"
        >
        <Flex justify="center" align="center" height="100%" width={"100%"}>
            {/* Center Buttons */}
            <Flex justify="flex-start" gap={1} height="100%" align={"center"} width={"33%"}>
            </Flex>

            <Flex 
                justify="flex-center" justifyContent="center" gap={1} flex="2" height="100%" align="baseline" width={"34%"} overflow={"hidden"}
                >
                {getFillResponse()}
                {getReviewResponse()}
            </Flex>

            {/* Right Buttons */}
            <Flex justify="flex-end" gap={2} height="100%" paddingRight={"24px"} width={"33%"} align={"top"} paddingTop={"16px"}>
                {
                    !formData?.is_collaborator && (
                        <Tooltip label={"Already up to date"}
                            isDisabled={updatedData.length != 0}
                            placement='bottom'
                            marginRight={"8px"}
                            bg={"#8d8d8d"}
                            color={"#f2f2f2"}
                            fontWeight={500}
                            fontFamily="'Inter', sans-serif" 
                            fontSize={"12px"}
                            offset={[0, -3]}
                            overflow={"hidden"}
                        >
                            <Button 
                                height="32px"
                                bg={updatedData.length ? "#2584fd" : "transparent"} 
                                _hover={updatedData.length ? "#2584fd" : null}
                                onClick={() => saveChanges()}
                                color={updatedData.length ? "white" : "#1d1d1d"}
                                fontWeight={updatedData.length ? "semibold" : "regular"}
                                isDisabled={updatedData.length == 0}
                                paddingX={"12px"}
                                fontSize={"14px"}
                                _disabled={{
                                    backgroundColor: "transparent",
                                    opacity: 1,
                                    cursor: "not-allowed",
                                }}
                            >Save draft</Button>
                        </Tooltip>
                    )
                }

                {
                    !formData?.is_collaborator && (
                        <>
                            <Tooltip label={"Save changes in original document"} 
                                placement='bottom'
                                marginRight={"8px"}
                                bg={"#8d8d8d"}
                                color={"#f2f2f2"}
                                fontWeight={500}
                                fontFamily="'Inter', sans-serif" 
                                fontSize={"12px"}
                                offset={[0, -3]}
                                overflow={"hidden"}
                            >
                                <Button 
                                    height="32px"
                                    bg={"#2584fd"} 
                                    _hover={"#2584fd"}
                                    onClick={() => setIsModalOpen(true)}
                                    color={"white"}
                                    fontFamily={"sans-serif"}
                                    paddingX={"12px"}
                                    fontWeight={"semibold"}
                                    fontSize={"14px"}
                                >Finalize & Export</Button>
                            </Tooltip>

                            <Modal
                                isOpen={isModalOpen}
                                onClose={() => setIsModalOpen(false)}
                                isCentered
                                size="lg"
                                motionPreset="slideInBottom"
                            >
                                <ModalOverlay
                                />
                                <ExportModal setIsModalOpen={setIsModalOpen} formData={formData} saveFinalChanges={saveFinalChanges}/>
                            </Modal>
                        </>
                    ) 
                }
            </Flex>
        </Flex>
        </GridItem>
    )
}

const ExportModal = ({setIsModalOpen, formData, saveFinalChanges}) => {
    const onClose = () => setIsModalOpen(false);
    const [docType, setDocType] = useState('')
    const [exportType, setExportType] = useState('source')
    const [isDisabled, setIsDisabled] = useState(true)
    const [saveToLibrary, setSaveToLibrary] = useState('no')
    const [attachments, setAttachments] = useState('skip')

    React.useEffect(() => {
        const fileName = formData?.metadata?.original_filename
        const fileExtension = fileName?.split('.').pop();

        if (fileExtension === 'pdf') {
            setDocType('docx')
        }
        else if (fileExtension === 'xlsx') {
            setDocType('xlsx')
        }
        else if (fileExtension === 'docx') {
            setDocType('docx')
        }
        else {
            setDocType('')
        }
    }, [])

    React.useEffect(() => {
        if (docType == '' || exportType == '') {
            setIsDisabled(true)
        } else if (exportType == 'company') {
            setIsDisabled(true)
        } else {
            setIsDisabled(false)
        }
    }, [docType, exportType])

    return (
        <ModalContent>
            <ModalHeader>Export Options</ModalHeader>
            <Box borderBottom="1px solid #e2e8f0" /> {/* Divider */}
            <ModalBody>
                <Box>
                    <Text fontWeight="bold" mt="8px" mb="8px">Export Type</Text>
                    <HStack spacing={6}> {/* Increased spacing from 4 to 6 */}
                        <label style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                            <input 
                                type="radio" 
                                name="docType" 
                                value="pdf" 
                                checked={docType === 'pdf'} 
                                onChange={() => setDocType('pdf')} 
                            />
                            PDF
                        </label>
                        <label style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                            <input 
                                type="radio" 
                                name="docType" 
                                value="xlsx" 
                                checked={docType === 'xlsx'} 
                                onChange={() => setDocType('xlsx')} 
                            />
                            Excel (XLSX)
                        </label>
                        <label style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                            <input 
                                type="radio" 
                                name="docType" 
                                value="docx" 
                                checked={docType === 'docx'} 
                                onChange={() => setDocType('docx')} 
                            />
                            DOCX
                        </label>
                    </HStack>
                </Box>
                <Box mt={6}>
                    <Text fontWeight="bold" mb="8px">Export In</Text>
                    <HStack spacing={4}>
                        <label style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                            <input 
                                type="radio" 
                                name="exportType" 
                                value="source" 
                                checked={exportType === 'source'} 
                                onChange={() => setExportType('source')} 
                            />
                            Source Template
                        </label>
                        <label style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                            <input 
                                type="radio" 
                                name="exportType" 
                                value="company" 
                                checked={exportType === 'company'} 
                                onChange={() => setExportType('company')} 
                            />
                            Company Template
                        </label>
                    </HStack>
                    {
                        exportType === 'company' && (
                            <Box 
                                width="100%" 
                                height="50px" 
                                bg="#f2f2f2" 
                                color="#8d8d8d" 
                                display="flex" 
                                justifyContent="center" 
                                alignItems="center" 
                                borderRadius="4px" 
                                fontSize="14px" 
                                fontWeight="500"
                                marginTop={"8px"}
                            >
                                No template files in library
                            </Box>
                        )
                    }
                </Box>
                <Box mt={6}>
                    <Text fontWeight="bold" mb="8px">Save To Library</Text>
                    <HStack spacing={4}>
                        <label style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                            <input 
                                type="radio" 
                                name="saveToLibrary" 
                                value="source" 
                                checked={saveToLibrary === 'yes'} 
                                onChange={() => setSaveToLibrary('yes')} 
                            />
                            Yes
                        </label>
                        <label style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                            <input 
                                type="radio" 
                                name="saveToLibrary" 
                                value="source" 
                                checked={saveToLibrary === 'no'} 
                                onChange={() => setSaveToLibrary('no')} 
                            />
                            No
                        </label>
                    </HStack>
                    {
                        saveToLibrary === 'yes' && (
                            <Box 
                                width={"100px"}
                                height="36px"
                                border={"1px solid #adadad"}
                                borderRadius={"4px"}
                                mt={2}
                                _hover={{
                                    backgroundColor: "#f2f2f2",
                                    cursor: "pointer",
                                }}
                            >
                                <HStack gap={0}>
                                    <IconButton
                                        sx={{ padding:0, backgroundColor: "transparent", _hover:{backgroundColor: "transparent"}, height: "32px", width: "32px"}}
                                    >
                                        <FolderOpenOutlined
                                            sx={{ padding:0, fontSize: 20, color: "#5d5d5d", backgroundColor: "transparent" }}
                                        />
                                    </IconButton>
                                    <Text
                                        color={"#1d1d1d"}
                                        lineHeight={"32px"}
                                        fontSize={"14px"}
                                    >
                                        Library
                                    </Text>
                                </HStack>
                            </Box>
                        )
                    }
                </Box>
                <Box mt={6}>
                    <Text fontWeight="bold" mb="8px">Attachments</Text>
                    <HStack spacing={4}>
                        <label style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                            <input 
                                type="radio" 
                                name="attachments" 
                                value="exportAsZip" 
                                checked={attachments === 'exportAsZip'} 
                                onChange={() => setAttachments('exportAsZip')} 
                            />
                            Export As ZIP
                        </label>
                        <label style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                            <input 
                                type="radio" 
                                name="attachments" 
                                value="appendix" 
                                checked={attachments === 'appendix'} 
                                onChange={() => setAttachments('appendix')} 
                            />
                            Include as Appendix
                        </label>
                        <label style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                            <input 
                                type="radio" 
                                name="attachments" 
                                value="skip" 
                                checked={attachments === 'skip'} 
                                onChange={() => setAttachments('skip')} 
                            />
                            Skip Attachments
                        </label>
                    </HStack>
                </Box>
            </ModalBody>
            <ModalFooter>
                <VStack>
                    <HStack>
                        <Button variant="outline" mr={3} onClick={onClose}>
                            Close
                        </Button>
                        <Button 
                            color="white" 
                            bgColor={"#2584FD"} 
                            _hover={{ bgcolor: "#2584FD" }}
                            onClick={saveFinalChanges}
                            disabled={isDisabled}
                            _disabled={{
                                backgroundColor: "#2584FD",
                                opacity: 0.5,
                                cursor: "not-allowed",
                            }}
                        >
                            Export Now
                        </Button>
                    </HStack>
                    <Text alignSelf="flex-end" fontSize={"14px"} >
                        Total Size: 2.5 MB
                    </Text>
                </VStack>
            </ModalFooter>
        </ModalContent>
    )
}

export default TopRight;